module.exports = __webpack_public_path__ + "img/icon-vot-viewcontest.9f7ec2cc.png";